"use client";

import {
  createContext,
  useContext,
  useState,
  useEffect,
  type ReactNode,
} from "react";

interface AuthContextType {
  accessToken: any;
  login: (data: any) => void;
  logout: () => void;
}

const AUTH_KEY = "customerAccessToken";

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [accessToken, setAccessToken] = useState<any>(null);

  // Check for existing login data on component mount
  useEffect(() => {
    const storedAuth = localStorage.getItem(AUTH_KEY);
    if (storedAuth) {
      try {
        const parsedAuth = JSON.parse(storedAuth);
        setAccessToken(parsedAuth);
      } catch (error) {
        console.error("Failed to parse stored auth data:", error);
        localStorage.removeItem(AUTH_KEY);
      }
    }
  }, []);

  const login = (data: any) => {
    setAccessToken(data);
    localStorage.setItem(AUTH_KEY, JSON.stringify(data));
  };

  const logout = () => {
    setAccessToken(null);
    localStorage.removeItem(AUTH_KEY);
  };

  return (
    <AuthContext.Provider value={{ accessToken, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    return {
      accessToken: null,
      login: () => {},
      logout: () => {},
    };
  }
  return context;
}
